/**
 * PayrollItemTable — PAY-7 placeholder
 *
 * A tételek megjelenítéséhez szükséges GET /payroll/runs/:id/items endpoint
 * a PAY-7 scope-on kívül esik (a PAY-6 nem vezette be). A tényleges lista
 * a PAY-7 follow-up story-ban kerül megvalósításra.
 */

import { Card, CardContent } from '@kgc/ui';

interface PayrollItemTableProps {
  runId: string;
}

export function PayrollItemTable({ runId: _runId }: PayrollItemTableProps) {
  return (
    <Card>
      <CardContent className="py-8">
        <p className="text-center text-muted-foreground text-sm">
          A tételek megtekintése fejlesztés alatt (PAY-7 follow-up —{' '}
          <code className="font-mono text-xs">GET /payroll/runs/:id/items</code> endpoint szükséges)
        </p>
      </CardContent>
    </Card>
  );
}
